import _inject from "@stylexjs/stylex/lib/stylex-inject";
import React from 'react';
import * as stylex from '@stylexjs/stylex';
import Text from "nood-comp/src/comp/text/Text";
import { NavLink } from "react-router-dom";
import ElapsedTime from "nood-comp/src/util/date/ElapsedTime";
import Tag from "nood-comp/src/comp/ui/tag/Tag";
import { color } from "nood-comp/src/util/ui/color";
import Table from "nood-comp/src/comp/data/table/Table";
import { queryStringMod } from "nood-comp/src/util/converters/converters";
export default function AuditLogs(props) {
  var _getCorrectColor = function _getCorrectColor(code) {
    if (code >= 200 && code < 300) {
      return '#d0f6b0';
    } else if (code >= 300 && code < 400) {
      return '#f384dd';
    } else if (code >= 400 && code < 500) {
      return '#ef6767';
    } else {
      return '#e23131';
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Table, {
    data_source: "/audit-logs",
    paging: {
      sorters: [{
        property: 'created_dt',
        isAsc: false
      }]
    },
    cols: [{
      property: "method",
      width: 100,
      icon: "terminal",
      filterPlaceholder: "Method",
      content: function content(v, idx) {
        return /*#__PURE__*/React.createElement(NavLink, {
          to: queryStringMod({
            "do": "view",
            id: v.id
          })
        }, v.method);
      },
      filterType: "dropdown",
      dropdownFilterOptions: [{
        value: 'GET',
        code: 'GET'
      }, {
        value: 'POST',
        code: 'POST'
      }, {
        value: 'PUT',
        code: 'PUT'
      }, {
        value: 'DELETE',
        code: 'DELETE'
      }, {
        value: 'PATCH',
        code: 'PATCH'
      }, {
        value: 'QUERY',
        code: 'QUERY'
      }, {
        value: 'OPTIONS',
        code: 'OPTIONS'
      }]
    }, {
      property: 'user_role',
      width: 100,
      icon: "user",
      filterPlaceholder: "User Role",
      filterType: 'dropdown',
      dropdownFilterOptions: [{
        value: 'ORG_MGR',
        code: 'Org Admin'
      }, {
        value: 'A',
        code: 'App Admin'
      }, {
        value: 'P',
        code: 'Public'
      }]
    }, {
      label: "Operation",
      content: function content(v, idx) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, v.operation, " ", /*#__PURE__*/React.createElement("br", null), v.browser.path && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
          size: 12,
          secondary: true
        }, v.browser.path), /*#__PURE__*/React.createElement(Text, {
          size: 12,
          secondary: true
        }, v.browser.query_string)));
      }
    }, {
      label: "Response",
      width: 120,
      filterType: 'dropdown',
      icon: "hash",
      property: "response_code",
      dropdownFilterOptions: [{
        value: 200,
        code: '2XX'
      }, {
        value: 300,
        code: '3XX'
      }, {
        value: 400,
        code: '4XX'
      }, {
        value: 500,
        code: '5XX'
      }],
      content: function content(log, idx) {
        var colour = _getCorrectColor(log.response_code);
        var textColour = color.chooseCorrectForegroundColor({
          backgroundHex: colour,
          foregroundHexDark: "#333333",
          foregroundHexLight: "#fefefe"
        });
        return /*#__PURE__*/React.createElement(Tag, {
          value: log.response_code,
          textColor: textColour,
          color: colour,
          monospace: true
        });
      }
    }, {
      label: "",
      width: 50,
      content: function content(log, idx) {
        return /*#__PURE__*/React.createElement(ElapsedTime, {
          datetime: log.created_dt,
          key: "audit-log-".concat(log.id)
        });
      }
    }]
  }));
}

// @ts-ignore
_inject("@media(min-width:501px){.evbw5gen.evbw5gen{left:270px}}", 4200);
_inject("@media(max-width:500px){.ev103ggzd.ev103ggzd{left:0}}", 4200);
_inject("@media(max-width:500px){.ev1qqrqh5.ev1qqrqh5{bottom:50px}}", 4200);